import { render, staticRenderFns } from "./newAdd.vue?vue&type=template&id=24e1844e&scoped=true"
import script from "./newAdd.vue?vue&type=script&lang=js"
export * from "./newAdd.vue?vue&type=script&lang=js"
import style0 from "./newAdd.vue?vue&type=style&index=0&id=24e1844e&prod&scoped=true&lang=scss"
import style1 from "./newAdd.vue?vue&type=style&index=1&id=24e1844e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1844e",
  null
  
)

export default component.exports